import { isApiError, unwrap } from "@sagot/api-client";
import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import { useApi } from "../../../../session/session-provider";
import type { ConnectorTestIn, ConnectorTestOut } from "./connector-api-types";

/** Why the call itself did not come back (the request may still have failed at the endpoint: that is an answer, `ok: false`). */
export type TestFailure = "rate_limited" | "not_found" | "forbidden" | "plan" | "network" | "unknown";

export function testFailureOf(error: unknown): TestFailure {
  if (!isApiError(error)) return "unknown";
  if (error.kind === "network" || error.kind === "timeout") return "network";
  switch (error.status) {
    case 429:
      return "rate_limited";
    case 404:
      return "not_found";
    case 403:
      return "forbidden";
    case 402:
      return "plan";
    default:
      return "unknown";
  }
}

/** Sends the request of a Data connector step once, with sample values; the answer names the fields it found, never their contents. */
export function useConnectorTest(): UseMutationResult<ConnectorTestOut, unknown, ConnectorTestIn> {
  const api = useApi();
  return useMutation({ mutationFn: (body: ConnectorTestIn) => unwrap(api.POST("/v1/workflows/connector-test", { body })) });
}
